import { z } from 'zod';

export const LocationSchema = z.object({
  city: z.string().optional(),
  state: z.string().optional(),
  postalCode: z.string().optional(),
  address: z.string().optional(),
  coordinates: z.string(),
});

export const OptionSchema = z.object({
  id: z.string().optional(),
  description: z.string().optional(),
  label: z.string().optional().default(''),
  nameId: z.string().optional(),
  value: z.string().or(z.number()),
});
